<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to thank my partner, Alex; children, Debbie and Michael; and friends who have given endless support and encouragement in the making of this book. To my publisher, who once again has shown faith in my ability as a writer, and all the people who have given great reviews on my first book. Thank you all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?208bfebe